(function () {
  var wordsToBold = [
    'Lumo',
    'Ono',
    'Kira',
    'Nivo',
    'Zelo',
    'Orix',
    'Filo',
    'Tavo',
    'Mino',
    'Vira',
    'Zeno',
    'Siva',
    'Xero',
    'Twin',
    'Semplice',
    'Duo',
    'Ampia',
    'Velo',
    'Forte'
  ];

  function escapeRegex(text) {
    return text.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  }

  function boldCardHeadings() {
    document.querySelectorAll('.card-heading').forEach(function (el) {
      if (el.dataset.boldApplied === 'true') return;

      var html = el.innerHTML;

      wordsToBold.forEach(function (word) {
        var regex = new RegExp('(^|[\\s>])(' + escapeRegex(word) + ')(?=[\\s<.,;:!?-]|$)', 'g');

        html = html.replace(regex, function (match, before, foundWord) {
          return before + '<strong>' + foundWord + '</strong>';
        });
      });

      el.innerHTML = html;
      el.dataset.boldApplied = 'true';
    });
  }

  document.addEventListener('DOMContentLoaded', boldCardHeadings);

  window.addEventListener('load', boldCardHeadings);

  document.addEventListener('click', function () {
    setTimeout(boldCardHeadings, 500);
    setTimeout(boldCardHeadings, 1200);
  });

  var observer = new MutationObserver(function () {
    boldCardHeadings();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
})();